import { Eye, EyeOff } from "lucide-react";

// Treats only "confidential" as confidential; everything else (searchable/private) is searchable.
export function VisibilityBadge({ status, testid }) {
  const confidential = status === "confidential";
  const cls = confidential
    ? "border-[#F5A623]/50 text-[#8A5A06] bg-[#F5A623]/10"
    : "border-[#10B981]/45 text-[#0B7A55] bg-[#10B981]/10";
  const Icon = confidential ? EyeOff : Eye;
  return (
    <span data-testid={testid} className={`inline-flex items-center gap-1 text-[0.6rem] font-mono uppercase tracking-wider px-2 py-0.5 border ${cls}`}>
      <Icon className="h-3 w-3" /> {confidential ? "Confidential" : "Searchable"}
    </span>
  );
}
